// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Constants
import {
  UPLOAD_ID_LANDING_CONDITIONS,
  UPLOAD_ID_LANDING_CONDITION_ASSET_PROPS,
  UPLOAD_ID_LANDING_CONDITION_DESCRIPTION_TEST_ID,
  UPLOAD_ID_LANDING_CONDITION_ASSET_TEST_ID,
  UPLOAD_ID_LANDING_DESCRIPTION_PROPS,
} from './constants/upload-id-landing.constants';
// Components
import { IconComponent, ParagraphComponent } from '@openbank/ziniaweb-ui-components';
// Hooks
import { useUploadIdLandingHook } from './hooks/upload-id-landing.hook';
// Styles
import {
  UploadIdLandingViewStyled,
  UploadIdLandingListComponentStyled,
  UploadIdLandingListItemComponentStyled,
} from './upload-id-landing.view.styled';
// Translations
import { DESCRIPTIONS, DOCUMENTS } from './translations/upload-id-landing.translations';
// Types
import { UploadIdLandingConditionType } from './types/upload-id-landing-condition.type';

const UploadIdLandingView = (): React.JSX.Element => {
  const { documentType } = useUploadIdLandingHook(),
    valuesProps = { document: <FormattedMessage id={DOCUMENTS[documentType]} /> };

  return (
    <UploadIdLandingViewStyled>
      <ParagraphComponent {...UPLOAD_ID_LANDING_DESCRIPTION_PROPS}>
        <FormattedMessage id={DESCRIPTIONS[documentType]} values={valuesProps} />
      </ParagraphComponent>
      <UploadIdLandingListComponentStyled>
        {UPLOAD_ID_LANDING_CONDITIONS.map(
          ({ assetId: icon, text, testId }: UploadIdLandingConditionType, index: number) => (
            <UploadIdLandingListItemComponentStyled key={index}>
              <IconComponent
                {...{ ...UPLOAD_ID_LANDING_CONDITION_ASSET_PROPS, icon }}
                dataTestId={testId + UPLOAD_ID_LANDING_CONDITION_ASSET_TEST_ID}
              />
              <ParagraphComponent testId={testId + UPLOAD_ID_LANDING_CONDITION_DESCRIPTION_TEST_ID}>
                <FormattedMessage id={text[documentType]} />
              </ParagraphComponent>
            </UploadIdLandingListItemComponentStyled>
          )
        )}
      </UploadIdLandingListComponentStyled>
    </UploadIdLandingViewStyled>
  );
};

export { UploadIdLandingView };
